export const SET_WAIVER_FORMS = 'SET_WAIVER_FORMS'
export const SET_WAIVER_FORM_FIELD = 'SET_WAIVER_FORM_FIELD'
